import { useSelectedLanguageName } from '@/hooks/useSelectedLanguageName'
import { AnswerType } from '@app-studio-web/ui/types'
import QuizChoicePage from './QuizChoicePage'

const answers: AnswerType[] = [
  {
    emoji: '🗣️',
    title: 'pages.quizOnboarding.skillFocus.answer1',
    value: 'speaking',
  },
  {
    emoji: '🗣️',
    title: 'pages.quizOnboarding.skillFocus.answer2',
    value: 'pronunciation',
  },
  {
    emoji: '🎧',
    title: 'pages.quizOnboarding.skillFocus.answer3',
    value: 'listening',
  },
  {
    emoji: '✍️',
    title: 'pages.quizOnboarding.skillFocus.answer4',
    value: 'writing',
  },
  {
    emoji: '📖',
    title: 'pages.quizOnboarding.skillFocus.answer5',
    value: 'reading',
  },
]

export default function SkillFocusPage() {
  const language = useSelectedLanguageName()

  return (
    <QuizChoicePage
      answers={answers}
      title="pages.quizOnboarding.skillFocus.title"
      translationInterpolation={{ language }}
    />
  )
}
